module.exports = __webpack_public_path__ + "img/other.d245e990.svg";